import { inject, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

import { PurchasingServiceCapacitor } from 'army-builder-shared/src/lib';
import { SubscriptionService } from '../subscription/subscription.service';

export const PURCHASE_STATE = {
    loading: 'loading',
    loaded: 'loaded',
    error: 'error'
};

@Injectable()
export class FalloutPurchasingServiceCapacitor extends PurchasingServiceCapacitor {
    protected purchasesSub: Subscription;
    subscriptionService = inject(SubscriptionService);

    isOwned(productId: string): boolean {
        const purchaseKey = productId.toLowerCase();
        if (purchaseKey === 'core') {
            return true;
        }

        return (
            this.subscriptionService.userHasAccess() ||
            this.userPurchases.includes('all_access') ||
            this.userPurchases.includes(purchaseKey)
        );
    }

    isItemAvailable(item: any): boolean {
        if (!item?.packs) {
            return false;
        }
        for (const pack of item.packs) {
            if (this.isOwned(pack)) {
                return true;
            }
        }
        return false;
    }
}
